import { analyticsUtils } from '../../analyticsUtils';
import { AdapterOptions, AnalyticsAdapter } from '../../types';

export const facebook = (
  instanceOptions?: AdapterOptions,
): AnalyticsAdapter => {
  const options = instanceOptions;

  function log(message) {
    try {
      if (options?.debug) {
        options.logger(`FB: ${message}`);
      }
    } catch (error) {
      console.log(`FB: log error: ${error}`);
    }
  }

  function addVendor(): void {
    if (!verifyVendor()) {
      /* eslint-disable */
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        // @ts-ignore _fbh method not recognised but is required by Facebook Pixel implementation
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js',
      );
      /* eslint-enable */

      log('addVendor - connect.facebook.net/en_US/fbevents.js');
    } else {
      log('addVendor - `fbq` already added');
    }
  }

  function verifyVendor(): boolean {
    return typeof window !== 'undefined' && !!window.fbq;
  }

  function initialise(id: string): boolean {
    if (!verifyVendor() || !id) {
      return false;
    }

    window.fbq('init', id);
    log(`initialise: ${id}`);

    return true;
  }

  function grantConsent(): void {
    if (verifyVendor()) {
      window.fbq('consent', 'grant');
    }
  }

  function revokeConsent(): void {
    if (verifyVendor()) {
      window.fbq('consent', 'revoke');
    }
  }

  function pageView(): void {
    if (verifyVendor()) {
      window.fbq('track', 'PageView');
      log('pageView');
    }
  }

  function trackEvent(data: Record<string, unknown>): void {
    const requiredData = analyticsUtils.getGenericData(data);
    const hasRequiredData = Object.keys(requiredData).length > 0;

    if (verifyVendor() && hasRequiredData) {
      let eventType = 'trackCustom';
      let title = `${requiredData.section} ${requiredData.label}`;

      if (data.isPixelStandardEvent) {
        eventType = 'track';
        title = requiredData.label as string;
        delete requiredData.isPixelStandardEvent;
      }

      window.fbq(eventType, title, requiredData);
      log(`track - ${title}`);
    }
  }

  return {
    addVendor,
    grantConsent,
    initialise,
    pageView,
    revokeConsent,
    trackEvent,
    verifyVendor,
  };
};
